import { ApiClient, ApiResponse } from '../client';

export interface StoreCategory {
  _id: string;
  name: string;
  isActive: boolean;
  pinColor: string;
}

export interface StoreLocation {
  _id: string;
  name: string;
  address: string;
  location: { coordinates: [number, number] }; // [lng, lat]
  category: StoreCategory;
  contactInfo?: { phone?: string; email?: string; website?: string };
  isActive?: boolean;
}

export class StoreService {
  private client: ApiClient;
  
  constructor(client: ApiClient) {
    this.client = client;
  }
  
  public async getCategories(): Promise<ApiResponse<StoreCategory[]>> {
    return await this.client.get<StoreCategory[]>('/stores/categories', {
      useCache: true,
      cacheTTL: 5 * 60 * 1000 // 5 minutos de caché
    });
  }

  public async updateCategory(id: string, categoryData: Partial<StoreCategory>): Promise<ApiResponse<StoreCategory>> {
    return await this.client.put<StoreCategory>(`/stores/categories/${id}`, categoryData);
  }

  public async getStores(params: any): Promise<ApiResponse<StoreLocation[]>> {
    return await this.client.get<StoreLocation[]>('/stores', {
      params,
      useCache: false 
    });
  }

  // Endpoints administrativos nuevos creados (Full CRUD + KMZ handler)

  public async createCategory(categoryData: Partial<StoreCategory>): Promise<ApiResponse<StoreCategory>> {
    return await this.client.post<StoreCategory>('/stores/categories', categoryData);
  }

  public async deleteCategory(id: string): Promise<ApiResponse<any>> {
    // Retorna empty obj en success true
    return await this.client.delete<any>(`/stores/categories/${id}`);
  }

  public async uploadKMZ(file: File): Promise<ApiResponse<any>> {
    const formData = new FormData();
    formData.append('file', file);

    return await this.client.post<any>('/stores/upload', formData);
  }

  // --- CRUD Tiendas Puntos (Stores) ---

  public async createStore(storeData: Partial<StoreLocation>): Promise<ApiResponse<StoreLocation>> {
    return await this.client.post<StoreLocation>('/stores', storeData);
  }

  public async updateStore(id: string, storeData: Partial<StoreLocation>): Promise<ApiResponse<StoreLocation>> {
    return await this.client.put<StoreLocation>(`/stores/${id}`, storeData);
  }

  public async deleteStore(id: string): Promise<ApiResponse<any>> {
    return await this.client.delete<any>(`/stores/${id}`);
  }
}
